import type { Product } from '../types/products.types';
import { isMoneyJson } from './productTransform';

export const getProductCurrency = (product?: Product | null): string => {
    const moneySetting = product?.config_settings?.find((s) => isMoneyJson(s.value));
    return isMoneyJson(moneySetting?.value) ? moneySetting!.value.currency : 'GBP';
};
